import "./carrier-rates-summary.css";

import { useContext } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import { useSelectedCarrier } from "~/features/quote/hooks/use-quote-hooks.ts";

import { useCarrierPageLoader } from "../../../../hooks/use-carrier-selection-hooks.ts";
import { CarrierCard } from "../carrier-card/carrier-card.tsx";

export const CarrierRatesSummary = () => {
	const { quoteState } = useContext(QuoteDetailsContext);
	const selectedCarrier = useSelectedCarrier(quoteState);
	const { pageData } = useCarrierPageLoader();

	if (!selectedCarrier) {
		return (
			<div className={"carrier-rates-summary-wrapper"}>
				<div
					className={"carrier-rates-summary-empty"}
					data-testid={"carrier-rates-summary-empty"}
				>
					No carrier selected.
				</div>
			</div>
		);
	}

	return (
		<div className={"carrier-rates-summary-wrapper"}>
			<CarrierCard
				carrierPrice={selectedCarrier}
				isReadOnly={true}
				onStepChange={() => undefined}
				pageData={pageData}
			/>
		</div>
	);
};
